/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectSimulationRequest } from '../../models/project-simulation-request';
import { ProjectSimulationResult } from '../../models/project-simulation-result';

export interface SimulationsControllerProjectSimulation$Params {

/**
 * The ID of the project.
 */
  id: string;
      body: ProjectSimulationRequest
}

export function simulationsControllerProjectSimulation(http: HttpClient, rootUrl: string, params: SimulationsControllerProjectSimulation$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectSimulationResult>> {
  const rb = new RequestBuilder(rootUrl, simulationsControllerProjectSimulation.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectSimulationResult>;
    })
  );
}

simulationsControllerProjectSimulation.PATH = '/planning-projects/v1/simulations/{id}';
